import React, {useEffect, useState} from 'react';
import {Col, Form, InputNumber, Row, Switch, TimePicker, Tooltip} from "antd";
import dayjs from "dayjs";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {t} from "i18next";

const ShiftGps = ({form}) => {

    const [isCheckInByCount,setIsCheckInByCount] = useState(false)
    const [isPercentage,setPercentage] = useState(false)

    const format = 'HH:mm';
    useEffect(() => {

        if(form.getFieldValue("checkInByCount") !== undefined){
            setIsCheckInByCount(form.getFieldValue("checkInByCount"))
        }

        if(form.getFieldValue("attendancePercentage") !== undefined){
            setPercentage(form.getFieldValue("attendancePercentage"))
        }

    }, [form.getFieldValue("checkInByCount") || form.getFieldValue("attendancePercentage") ]);

    return (
        <div>
            <Row gutter={12}>
                <Col xxl={{span: 12}} xl={{span: 12}} lg={{span: 12}}>
                    <Form.Item
                        name="checkInByCount"
                        labelAlign="right"
                        initialValue={false}
                      >
                        <Switch
                            size="small"
                            className={'mr-1 mb-1'}
                            checked={isCheckInByCount}
                            onChange={(v) => {
                                form.setFieldValue("checkInByCount", v)
                               setIsCheckInByCount(v)
                            }}
                        />
                        {t("shiftTitle.checkInFrequency")}

                    </Form.Item>

                </Col>
            </Row>
            {isCheckInByCount && <>
                <Row gutter={12}>
                    <Col
                        xxl={{span: 6}} xl={{span: 10}} lg={{span: 12}}
                    >
                        <Form.Item
                            labelCol={{
                                span: 24,
                            }}
                            wrapperCol={{
                                span: 24,
                            }}
                            label={t("shiftTitle.checkinLabel")}
                            name="minAttendanceCount"
                            labelAlign="right"
                            initialValue={2}
                            rules={[
                                {
                                    required: true,
                                    message: t("shiftTitle.checkinLabelRequire"),
                                },

                            ]}
                        >
                            <InputNumber
                                style={{
                                    width: "100%"
                                }}
                                min={0}
                                placeholder={t("shiftTitle.checkinLabelPlaceholder")}/>
                        </Form.Item>
                    </Col>
                    <Col
                        xxl={{span: 6}} xl={{span: 10}} lg={{span: 12}}
                    >

                        <Form.Item
                            initialValue={dayjs('02:00', format)}
                            labelCol={{
                                span: 24,
                            }}
                            wrapperCol={{
                                span: 24,
                            }}
                            label={t("shiftTitle.timeBetweenCheckIn")}
                            name="timeBetweenCheckIn"
                            labelAlign="right"
                        >
                            <TimePicker
                                style={{
                                    width: "100%"
                                }}
                                changeOnBlur={true}
                                format={format}/>
                        </Form.Item>


                    </Col>
                </Row>
                <Row gutter={12}>
                    <Col xxl={{span: 8}} xl={{span: 10}} lg={{span: 12}}>
                        <Form.Item
                            initialValue={false}
                            name="attendancePercentage" className="df__center-align">
                            <Switch
                                size="small"
                                className={'mr-1 mb-1'}
                                checked={isPercentage}
                                onChange={(v) => {
                                    form.setFieldValue("attendancePercentage", v)
                                    setPercentage(v)
                                }}
                            />
                            <span>{t("shiftTitle.attendancePercentage")}&nbsp;&nbsp;
                                <Tooltip title={t("shiftTitle.attendancePercentageToolTip")}>
                                    <QuestionCircleOutlined/>
                                </Tooltip>
                        </span>
                        </Form.Item>

                    </Col>
                </Row>
            </>
            }
        </div>
    );
};


export default ShiftGps;
